import { LOCALE_ID } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from "./app/app.module";

// Parité V1 : enableProdMode() supprimé (n'existe plus — l'optimisation de build joue ce rôle en Angular 21).
export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

// Parité V1 : ng2-pdf-viewer (module signature) charge son worker PDF.js depuis un CDN par défaut —
// on pointe vers la copie locale (angular.json copie node_modules/pdfjs-dist/legacy/build vers
// /assets/pdfjs/) pour fonctionner sans accès internet, comme tout le reste de l'application.
(window as any).pdfWorkerSrc = "/assets/pdfjs/pdf.worker.min.mjs";

// Le visualiseur PDF (ngx-extended-pdf-viewer / pdf.js) émet des console.warn "[fluent] Missing
// translations ..." codés en dur (aucune option de verbosité ne les contrôle) : le fichier de
// locale fr livré avec la bibliothèque ne couvre pas toutes les clés de l'interface. Bruit sans
// impact fonctionnel — on filtre uniquement ces messages, tout autre warning passe normalement.
const originalConsoleWarn = console.warn.bind(console);
console.warn = (...args: any[]) => {
  if (typeof args[0] === "string" && args[0].startsWith("[fluent]")) return;
  originalConsoleWarn(...args);
};

// Parité V1 : token string "BASE_URL" conservé tel quel (fourni à la plateforme comme dans ClientApp).
const providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];

platformBrowser(providers)
  .bootstrapModule(AppModule, {
    // Parité V1 : LOCALE_ID fourni ici EN PLUS de AppModule.providers (doublon d'origine conservé).
    providers: [{ provide: LOCALE_ID, useValue: "fr-FR" }],
  })
  .catch((err) => console.log(err));
